import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, retry, timeout } from 'rxjs/operators';
// import { extend } from 'lodash/extend';
import * as _ from 'lodash';
import { LodashService } from './lodash.service';
import { SettingsService } from './settings.service';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    auth_key: '',
    dco_site_id: '1',
    datatype: '1',
    method: 'GET',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class EfoEgiService {
  private egiAccountInformation: any = [];
  private endpoint: string = '';
  private endpointBg: string = '';
  private endpointCbr: string = '';
  private endpointHs: string = '';
  private configSettings: any = {};

  constructor(
    private http: HttpClient,
    private efoLd: LodashService,
    private appSettings: SettingsService,
  ) {
    this.init();
  }

  init(): void {
    this.configSettings = this.appSettings.get();
    this.endpoint = this.appSettings.apiUrl();
    this.endpointBg = environment.baseApiUrl;
    this.endpointCbr = environment.baseApiUrl;
    this.endpointHs = environment.baseApiUrl;
    console.log('egi.service configSettings', this.configSettings);
    httpOptions.headers = httpOptions.headers.set(
      'auth_key',
      this.configSettings.authKey,
    );
    httpOptions.headers = httpOptions.headers.set(
      'api_key',
      this.configSettings.apiKey,
    );
    console.log('endpoint', this.endpoint);
    console.log('auth_key', this.configSettings.apiKey);
    console.log('egi.service getData appSettings', this.configSettings);
    console.log('egi.service getData httpOptions.headers', httpOptions.headers);
  }

  extractData(res: Response): any {
    const body = res;
    return body || {};
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private handleTimeout<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getData(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'GET');
    httpOptions.headers = httpOptions.headers.set('timeout', `${60000}`);
    return this.http
      .post(this.endpoint + url, qParams, httpOptions)
      .pipe(timeout(36000))
      .pipe(map(this.extractData));
    // return this.http.post(this.endpoint + url, qParams, httpOptions).
    //   map(this.extractData);
  }

  getDataBg(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'GET');
    httpOptions.headers = httpOptions.headers.set('timeout', `${90000}`);
    return this.http
      .post(this.endpointBg + url, qParams, httpOptions)
      .pipe(map(this.extractData));
  }

  getDataCbr(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'GET');
    httpOptions.headers = httpOptions.headers.set('timeout', `${60000}`);
    return this.http
      .post(this.endpointCbr + url, qParams, httpOptions)
      .pipe(map(this.extractData));
  }

  getDataHs(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'GET');
    httpOptions.headers = httpOptions.headers.set('timeout', `${60000}`);
    return this.http
      .post(this.endpointHs + url, qParams, httpOptions)
      .pipe(map(this.extractData));
  }

  postData(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'POST');
    httpOptions.headers = httpOptions.headers.set('timeout', `${60000}`);
    return this.http
      .post(this.endpoint + url, qParams, httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  postDataBg(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'POST');
    return this.http
      .post(this.endpointBg + url, qParams, httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  postDataCbr(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'POST');
    return this.http
      .post(this.endpointCbr + url, qParams, httpOptions)
      .pipe(retry(0), catchError(this.handleError));
  }

  putData(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'PUT');
    return this.http
      .post(this.endpoint + url, qParams, httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  deleteData(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'DELETE');
    return this.http
      .post(this.endpoint + url, qParams, httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  deleteDataCbr(url: string, qParams: any): Observable<any> {
    if (!_.isUndefined(this.appSettings.get().authKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'auth_key',
        this.appSettings.get().authKey,
      );
    }
    if (!_.isUndefined(this.appSettings.get().apiKey)) {
      httpOptions.headers = httpOptions.headers.set(
        'api_key',
        this.appSettings.get().apiKey,
      );
    }
    httpOptions.headers = httpOptions.headers.set('method', 'DELETE');
    return this.http
      .post(this.endpointCbr + url, qParams, httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
}
